import { FC } from 'react'

import { Translation } from 'cng-common/features/translations'
import { ConfirmationDialog } from 'partner360/components/confirmationDialog/ConfirmationDialog'

import { BUSINESS_PRIORITIES_TRANSLATION_KEYS } from '../../../configs/translations'

const KEYS = BUSINESS_PRIORITIES_TRANSLATION_KEYS

interface IActivationConfirmationDialogProps {
  isVisible: boolean
  actionType: 'activate' | 'deactivate'
  onConfirm: () => void
  onReject: () => void
}

export const ActivationConfirmationDialog: FC<IActivationConfirmationDialogProps> = ({
  isVisible,
  actionType,
  onConfirm,
  onReject,
}) => (
  <ConfirmationDialog
    isVisible={isVisible}
    title={
      actionType === 'deactivate'
        ? KEYS.activationConfirmDialog.deactivationTitle
        : KEYS.activationConfirmDialog.activationTitle
    }
    confirmBtnText={KEYS.activationConfirmDialog.confirm}
    rejectBtnText={KEYS.activationConfirmDialog.cancel}
    isApplyNegative={actionType === 'deactivate'}
    onConfirm={onConfirm}
    onReject={onReject}
    content={
      <Translation
        text={
          actionType === 'deactivate'
            ? KEYS.activationConfirmDialog.messageDeactivate
            : KEYS.activationConfirmDialog.messageActivate
        }
      />
    }
  />
)

ActivationConfirmationDialog.displayName = 'ActivationConfirmationDialog'
